export { default } from './LinkAthenaPatientPopup';
